import React from 'react';
import { InfoWindow } from '@vis.gl/react-google-maps';
import AssetPopupContent from './AssetPopupContent';
import EventPopupContent from './EventPopupContent';
import { PopupType, AssetPopupContentData, EventPopupContentData } from '../../../../types/types';

interface PopupProps {
    anchor: google.maps.marker.AdvancedMarkerElement;
    data?: AssetPopupContentData | EventPopupContentData | null;
}

/**
 * Renders a popup window to the map using Google's InfoWindow from the Maps API.
 */
const Popup: React.FC<PopupProps> = ({
    anchor,
    data = null,
}) => {
    if (anchor && data) {
        return (
            <InfoWindow
                anchor={anchor}
                shouldFocus
                headerDisabled
                minWidth={350}
                maxWidth={350}
                style={{ zIndex: 1000 }}
            >
                {data.type === PopupType.Asset ? (
                    <AssetPopupContent
                        type={PopupType.Asset}
                        assetId={data.assetId}
                        date={data.date}
                    />
                ) : data.type === PopupType.Event ? (
                    <EventPopupContent 
                        type={PopupType.Event}
                        speed={data.speed}
                        eventName={data.eventName}
                        time={data.time}
                        driverId={data.driverId}
                        driverName={data.driverName}
                        location={data.location}
                        avlKeys={data.avlKeys}
                    />
                ) : (
                    <></>
                )}
            </InfoWindow>
        );
    }

    return null;
}

export default React.memo(Popup);